import { router } from '@/modules/trang-chu/router'

export default router
